
import React, { useRef, useState } from 'react';
import {
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  TextField,
  FormControlLabel,
  Checkbox,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
} from "@material-ui/core";
import { useDispatch, useSelector } from 'react-redux';
import { startAlerta } from '../../../../actions/ui/alertas';
import BuscadorPractica from '../../../turnos/coseguros/BuscadorPractica';
import { addLineaInsumos, addLineaPrestacion, insertLineaInsumo, insertLineaMedicamento, insertLineaPrestacion, insertLineasPorIdSolicitud } from '../../../../actions/liquidaciones/liquidaciones';
import { LIQUIDACIONES_LINEA_COMPORBANTE, LIQUIDACIONES_TIPO_SOLICITUD_LINEA } from '../../../../utils/constants';
import BuscadorMateriales from '../../../autorizaciones/UI/BuscadorMateriales';
import { ModalAddLineCampos } from '../ModalAddLineCampos';

export const TIPO_LINEA = {
  CodigoLiquidacion: 1,
  LineaNomenclador: 2,
  IdSolicitud: 3
}

export const ModalAddLine = (props) => {
  const dispatch = useDispatch();

  const { open, closeModalHandler, esLineaCodigoLiq, comprobanteSeleccionado,
    lineaComprobante, tipoLinea } = props;

  const { lineasPrestacionComprobante, lineasInsumosComprobante } = useSelector(
    (state) => state.liquidaciones
  );

  const title = tipoLinea === TIPO_LINEA.CodigoLiquidacion
    ? 'Código Liquidación'
    : tipoLinea === TIPO_LINEA.IdSolicitud
      ? 'líneas por Nro Orden'
      : lineaComprobante === LIQUIDACIONES_LINEA_COMPORBANTE.PRESTACION
        ? 'Práctica'
        : lineaComprobante === LIQUIDACIONES_LINEA_COMPORBANTE.INSUMO
          ? 'Insumo'
          : 'Medicamento';

  const [idSolicitud, setIdSolicitud] = useState();
  const [codigoPractica, setCodigoPractica] = useState(null);
  const [codigoMaterial, setCodigoMaterial] = useState(null);
  const [soloPrecarga, setSoloPrecarga] = useState(tipoLinea === TIPO_LINEA.IdSolicitud);

  // CAMPOS GRABAR SIN PRECARGAR
  const [importe, setImporte] = useState(0);
  const [coseguroFacturado, setCoseguroFacturado] = useState(0);
  const [cantidad, setCantidad] = useState(1);
  const [idCategoria, setIdCategoria] = useState();
  const [afiliadoTemp, setAfiliadoTemp] = useState();
  const [nroValidacion, setNroValidacion] = useState();
  const [afiInexistente, setAfiInexistente] = useState();
  const [idSolicitudLinea, setIdSolicitudLinea] = useState();
  //const [fechaPrestacion, setFechaPrestacion] = useState(new Date());
  const [fechaPrestacion, setFechaPrestacion] = useState(null);
  const [enableCheckAfiInexistente, setEnableCheckAfiInexistente] = useState(false);
  const [enableCheckPractInexistente, setEnableCheckPractInexistente] = useState(false);
  const [practInexistente, setPractInexistente] = useState();
  const [practicaTemp, setPracticaTemp] = useState();

  const [codigoMedicamento, setCodigoMedicamento] = useState(null);
  const codigoMedicamentoRef = useRef(null);

  const [debitoCapita, setDebitoCapita] = useState(false);
  const [efectorFacturacionDebitoCapita, setEfectorFacturacionDebitoCapita] = useState(null);
  const [importeMedicTabla, setImporteMedicTabla] = useState(0);

  const [idTipoSolicitudLinea, setIdTipoSolicitudLinea] = useState(null);
  const [afiliadoExternoTemp, setAfiliadoExternoTemp] = useState();

  const handleAddLinePrestacion = () => {
    if (tipoLinea === TIPO_LINEA.IdSolicitud) {
      if (!idSolicitud || idSolicitud === '' || Number(idSolicitud) === 0) {
        dispatch(startAlerta('Ingrese un IdSolicitud válido', "warning", "Error"));
      } else if (idTipoSolicitudLinea === null) {
        dispatch(startAlerta('Seleccione un Tipo de Solicitud', "warning", "Error"));
      } else {
        dispatch(insertLineasPorIdSolicitud(comprobanteSeleccionado?.idComprobante, Number(idTipoSolicitudLinea),
          Number(idSolicitud), closeModal));
      }
    } else if (!soloPrecarga) {
      if (!esLineaCodigoLiq && (!afiliadoTemp?.id_afiliado && !afiInexistente && !afiliadoExternoTemp?.id_afiliado)) {
        return dispatch(startAlerta("Debe seleccionar un afliliado para grabar la línea.", "warning", "Error"));
      } else if (lineaComprobante !== LIQUIDACIONES_LINEA_COMPORBANTE.MEDICAMENTO && (!importe || importe === 0)) {
        return dispatch(startAlerta("Debe ingresar un importe.", "warning", "Error"));
      } else if (lineaComprobante === LIQUIDACIONES_LINEA_COMPORBANTE.MEDICAMENTO && (!importeMedicTabla || importeMedicTabla === 0)) {
        return dispatch(startAlerta("Debe ingresar un importe.", "warning", "Error"));
      } else if (fechaPrestacion === null) {
        return dispatch(startAlerta("La fecha de prestación no puede estar vacía.", "warning", "Error"));
      }

      if (lineaComprobante === LIQUIDACIONES_LINEA_COMPORBANTE.PRESTACION) {
        if (enableCheckPractInexistente === false && !codigoPractica) {
          return dispatch(startAlerta("Debe seleccionar una práctica.", "warning", "Error"));
        }

        
        dispatch(insertLineaPrestacion(comprobanteSeleccionado?.idComprobante, fechaPrestacion, codigoPractica?.id,
          cantidad, importe, afiliadoTemp?.id_afiliado, idCategoria, null,
          null, nroValidacion, idSolicitudLinea,
          afiInexistente, false, coseguroFacturado, practInexistente, afiliadoExternoTemp?.id_afiliado));
        setCodigoPractica(null);
        setImporte(0);
        //ACA CIERRA EL MODAL  
        //closeModal();
      } else if (lineaComprobante === LIQUIDACIONES_LINEA_COMPORBANTE.INSUMO) {
        if (!codigoMaterial) {
          return dispatch(startAlerta("Debe seleccionar un insumo.", "warning", "Error"));
        }

        dispatch(insertLineaInsumo(comprobanteSeleccionado?.idComprobante, fechaPrestacion, codigoMaterial.codigoNum,
          cantidad, importe, afiliadoTemp?.id_afiliado, null,
          null, nroValidacion, idSolicitudLinea,
          afiInexistente, false /*, idAgenda */));
        setCodigoMaterial(null);
        setImporte(0);
        //closeModal();
      } else if (lineaComprobante === LIQUIDACIONES_LINEA_COMPORBANTE.MEDICAMENTO) {
        if (!codigoMedicamento) {
          return dispatch(startAlerta("Debe seleccionar un medicamento.", "warning", "Error"));
        }
        dispatch(insertLineaMedicamento(comprobanteSeleccionado?.idComprobante, fechaPrestacion, codigoMedicamento.idMedicamento,
          cantidad, importe, afiliadoTemp?.id_afiliado, soloPrecarga, afiInexistente, debitoCapita,
          efectorFacturacionDebitoCapita?.idEfectorFacturacion, importeMedicTabla
          /*, porcenDto, fechaInternacionDesde, fechaInternacionHasta, nroValidacion, idSolicitudLinea,
          , idCentroCosto
          /*, idAgenda */));
        setCodigoMedicamento(null);
        setImporte(0);
        //closeModal();
      }
    } else if (lineaComprobante === LIQUIDACIONES_LINEA_COMPORBANTE.PRESTACION) {
      if (!codigoPractica) {
        return dispatch(startAlerta("Debe seleccionar una práctica.", "warning", "Error"));
      } else if (lineasPrestacionComprobante.filter(s => s.newLine && s.idCodNom === codigoPractica.id).length > 0) {
        return dispatch(startAlerta("Tiene una línea cargada con la misma práctica sin grabar, debe grabarla primero.", "warning", "Error"));
      }

      const newLinePrest = {
        idItem: (Math.max(...lineasPrestacionComprobante.map(s => s.idItem)) + 1),
        idComprobante: comprobanteSeleccionado?.idComprobante,
        idCodNom: codigoPractica.id,
        codNom: codigoPractica.codNom,
        desNom: codigoPractica.desNom,
        fechaPrestacion: null,
        fechaInternacionDesde: null,
        fechaInternacionHasta: null,
        cantidad: 1,
        esCodigoLiquidacion: codigoPractica.esCodigoLiquidacion,
        importe: codigoPractica.esCodigoLiquidacion ? 0 : null,
        cantPracticasRealizadasAnoPrestacion: null,
        valorExterno: null,
        valorExcedeExterno: null,
        convenio: null,
        newLine: true,
      }

      dispatch(addLineaPrestacion(newLinePrest));
      closeModal();
    } else if (lineaComprobante === LIQUIDACIONES_LINEA_COMPORBANTE.INSUMO) {
      if (!codigoMaterial) {
        return dispatch(startAlerta("Debe seleccionar un insumo.", "warning", "Error"));
      } else if (lineasInsumosComprobante.filter(s => s.newLine && s.idMaterial === codigoMaterial.codigoNum).length > 0) {
        return dispatch(startAlerta("Tiene una línea cargada con el mismo material sin grabar, debe grabarla primero.", "warning", "Error"));
      }

      const newLineInsumo = {
        idItem: (Math.max(...lineasInsumosComprobante.map(s => s.idItem)) + 1),
        idComprobante: comprobanteSeleccionado?.idComprobante,
        idMaterial: codigoMaterial.codigoNum,
        codMat: codigoMaterial.codigo,
        desMat: codigoMaterial.descripcion,
        fechaPrestacion: new Date(),
        fechaInternacionDesde: null,
        fechaInternacionHasta: null,
        cantidad: 1,
        importe: esLineaCodigoLiq ? 0 : null,
        newLine: true,
      }

      dispatch(addLineaInsumos(newLineInsumo));
      closeModal();
    }
  }

  const closeModal = () => {
    setCodigoPractica(null);
    closeModalHandler();
  }

  const title2 = idTipoSolicitudLinea === LIQUIDACIONES_TIPO_SOLICITUD_LINEA.SCIENZA ? "lineas por Nro Pedido" : title;



  return (
    <Dialog
      fullWidth
      open={open}
      maxWidth={'md'}
      onClose={closeModal}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{`Agregar ${title2}`}</DialogTitle>
      <DialogContent>
        <Grid
          container
          spacing={2}
          style={{ width: "60%", margin: "auto", marginBottom: 25 }}
        >
          <Grid item xs={12}>
            {tipoLinea === TIPO_LINEA.IdSolicitud
              ?
              <>
                <Grid
                  container
                  spacing={2}
                >
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      type='number'
                      fullWidth
                      label={idTipoSolicitudLinea === LIQUIDACIONES_TIPO_SOLICITUD_LINEA.SCIENZA ? "Nro Pedido" : "Nro Orden"}
                      name="idSolicitud"
                      value={idSolicitud}
                      autoComplete="off"
                      autoFocus
                      onChange={(e) => setIdSolicitud(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === "Enter")
                          handleAddLinePrestacion();
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <FormLabel id="row-radio-buttons-type-solic-line-label">Tipo Solicitud</FormLabel>
                      <RadioGroup
                        row
                        aria-labelledby="row-radio-buttons-type-solic-line-label"
                        name="row-radio-buttons-type-solic-line"
                        // style={{ justifyContent: "space-around" }}
                        style={{ alignSelf: 'center' }}
                        value={idTipoSolicitudLinea ?? ''}
                        onChange={(e) => {
                          setIdTipoSolicitudLinea(e.target.value);
                        }}
                      >
                        {Object.entries(LIQUIDACIONES_TIPO_SOLICITUD_LINEA).map((item) => {
                          const label =
                            item[0].charAt(0) +
                            item[0].replace("_", " ").toLowerCase().slice(1);
                          return (
                            <FormControlLabel
                              key={item[1]?.toString()}
                              style={{ marginLeft: "0.5rem" }}
                              label={label}
                              value={item[1]?.toString()}
                              control={<Radio />}
                            // disabled={item[1] === LIQUIDACIONES_TIPO_SOLICITUD_LINEA.DISCAPACIDAD}
                            />
                          );
                        })}
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                </Grid>
              </>
              :
              lineaComprobante === LIQUIDACIONES_LINEA_COMPORBANTE.PRESTACION
                ?

                <BuscadorPractica
                  liquidaciones={true}
                  cod={codigoPractica}
                  label="Código Practica"
                  fieldsDisabled={enableCheckPractInexistente ? true : false}
                  esLineaCodigoLiq={esLineaCodigoLiq}
                  setCod={(val) => setCodigoPractica(val)}
                  idTipoNomenclador={comprobanteSeleccionado?.comprobanteContrato?.efectorFacturacion?.idTipoNomenclador}
                  idEfectorFacturacion={comprobanteSeleccionado?.comprobanteContrato?.efectorFacturacion?.idEfectorFacturacion}
                />
                :
                lineaComprobante === LIQUIDACIONES_LINEA_COMPORBANTE.INSUMO
                  ?
                  <BuscadorMateriales
                    cod={codigoMaterial}
                    label="Código Material"
                    fieldsDisabled={props.esDenunciaInternacion}
                    setCod={(val) => setCodigoMaterial(val)}
                  />
                  :
                  null
            }
          </Grid>
          {!soloPrecarga &&
            <ModalAddLineCampos
              lineaExistente={false}
              esLineaCodigoLiq={esLineaCodigoLiq}
              lineaComprobante={lineaComprobante}
              comprobanteSeleccionado={comprobanteSeleccionado}
              importe={importe}
              setImporte={setImporte}
              cantidad={cantidad}
              setCantidad={setCantidad}
              idCategoria={idCategoria}
              setIdCategoria={setIdCategoria}
              afiliadoTemp={afiliadoTemp}
              setAfiliadoTemp={setAfiliadoTemp}
              nroValidacion={nroValidacion}
              setNroValidacion={setNroValidacion}
              afiInexistente={afiInexistente}
              setAfiInexistente={setAfiInexistente}
              fechaPrestacion={fechaPrestacion}
              setFechaPrestacion={setFechaPrestacion}
              idSolicitudLinea={idSolicitudLinea}
              setIdSolicitudLinea={setIdSolicitudLinea}
              enableCheckAfiInexistente={enableCheckAfiInexistente}
              setEnableCheckAfiInexistente={setEnableCheckAfiInexistente}
              enableCheckPractInexistente={enableCheckPractInexistente}
              setEnableCheckPractInexistente={setEnableCheckPractInexistente}
              coseguroFacturado={coseguroFacturado}
              setCoseguroFacturado={setCoseguroFacturado}
              practInexistente={practInexistente}
              setPractInexistente={setPractInexistente}
              practicaTemp={practicaTemp}
              setPracticaTemp={setPracticaTemp}
              codigoPractica={codigoPractica}
              codigoMedicamentoRef={codigoMedicamentoRef}
              codigoMedicamento={codigoMedicamento}
              setCodigoMedicamento={setCodigoMedicamento}
              debitoCapita={debitoCapita}
              setDebitoCapita={setDebitoCapita}
              efectorFacturacionDebitoCapita={efectorFacturacionDebitoCapita}
              setEfectorFacturacionDebitoCapita={setEfectorFacturacionDebitoCapita}
              importeMedicTabla={importeMedicTabla}
              setImporteMedicTabla={setImporteMedicTabla}
              setAfiliadoExternoTemp={setAfiliadoExternoTemp}
              afiliadoExternoTemp={afiliadoExternoTemp}
            />
          }
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid container justify="center" style={{ marginBottom: 10 }}>
          <Grid item xs={4}>
            <Button
              style={{ marginLeft: '15%' }}
              onClick={closeModal}
              variant="contained"
              color="primary"
            >
              Cerrar
            </Button>
          </Grid>
          <Grid item xs={4} style={{ textAlign: 'center' }}>
            {tipoLinea !== TIPO_LINEA.IdSolicitud &&
              <FormControlLabel
                control={
                  <Checkbox
                    name="soloPrecarga"
                    checked={soloPrecarga}
                    disabled={tipoLinea === TIPO_LINEA.IdSolicitud}
                    onChange={(e) => {
                      setSoloPrecarga(e.target.checked);
                    }}
                  />
                }
                label="Solo-PreCarga"
              />
            }
          </Grid>
          <Grid item xs={4} style={{ textAlign: 'right' }}>
            <Button
              color="primary"
              variant="contained"
              style={{ marginRight: '15%' }}
              onClick={handleAddLinePrestacion}
            >
              Aceptar
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
